import React, { Component } from "react";
import { Link } from "react-router-dom";
import Instructions from "./instuctions/instruction";
import parse from 'html-react-parser';
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";
import { getStatus } from "../../action/application/getStatus";
import Cookies from 'universal-cookie';
import Loader from "../loader/loader";
import { frontEndLogs } from "../../action/logs/frontEndLogs";
import { PropTypes } from 'prop-types';
import withRouter from "../../withRouter";
import NavigateWrapper from "../../navigation";
import {getEmailFromStorage,isValidSessionId} from "../../utils/helpers/storageUtils";

export class DocumentVerifyMobile extends Component {

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            documentSteps: false,
            passportInstruction: false,
            drivinglicenseInstruction: false,
            selfieInstruction: false,
            documentType:'',
            instruction:true,
            instructionsSection:false,
            passportSection:false,
            drivinglicenseSection:false,
            isEnableDocumentsTabs:false,
            isSelectDocument:'',
            userLoginType:sessionStorage.getItem('userLoginType'),
            isLoading: false,
            isConnected: navigator.onLine,
        };

        this.handleChange = this.handleChange.bind(this);
        this.callSessionStatus = this.callSessionStatus.bind(this);
        this.getSessionStatus = this.getSessionStatus.bind(this);
        this.openinstruction = this.openinstruction.bind(this);
        this.passportInstructionOpen = this.passportInstructionOpen.bind(this);
        this.IDInstructionOpen = this.IDInstructionOpen.bind(this);
        this.veteranInstructionOpen = this.veteranInstructionOpen.bind(this);
        this.checkIntervalID = '';
    }

    componentDidMount(){
      window.dataLayer = window.dataLayer || {};
      this.setState({documentSteps:true,instruction:false});
      let applicationId = this.getApplicationIDInstorage();
      if(applicationId !== '' && applicationId !== null && applicationId !== undefined){
        this.sendDeviceDetectForHandoff();
      }

      this.callSessionStatus();

      window.dataLayer = window.dataLayer || {}; 
      let sessionId = isValidSessionId();
      if(sessionId){
        window.dataLayer.push({ 
            "event" : "metadata", 
            "LoginStatus" : "TRUE"
        });
      }
      
      if(applicationId !== '' && applicationId != null && applicationId !== undefined){
        window.dataLayer.push({
            "event" : "metadata",
            "applicationID" : applicationId
        });
      }

      window.addEventListener("online", this.handleOnline);
      window.addEventListener("offline", this.handleOffline);
      frontEndLogs('All available document are showed ' + applicationId, false, 200, 'componentDidMount');
      analyticsClickEvent('document_verify_displaed', '');
    }

    callSessionStatus() {
      this.checkIntervalID = setInterval(this.getSessionStatus, 30000);
    }

    async getSessionStatus() {
      let isValidSessionid = isValidSessionId();
      if(isValidSessionid){
        let email = getEmailFromStorage();
        const sessionObj={
          "email": email,
          "application_id":await this.getApplicationIDInstorage()
        }
        const sessionResult = await getStatus(sessionObj);
        const cookie = new Cookies();    
        if(sessionResult.data.statusCode !== undefined){
          if(sessionResult.data.statusCode === 400 && sessionResult.data.message === "Invalid Session") {
            // Remove cookie for Retailer Id once the user session is expired
            cookie.remove('retailerId', { path: '/' });

            this.props.navigate('/login');
            window.location.reload(true);
          }
        }
      } 
    }

    componentWillUnmount(){
      clearInterval(this.checkIntervalID);
      clearInterval(this.intervalID);

      window.removeEventListener("online", this.handleOnline);
      window.removeEventListener("offline", this.handleOffline);
    }

    handleOnline = () => {
      this.setState({ isConnected: true });
    };
    
    handleOffline = () => {
      this.setState({ isConnected: false });
    };

    sendDeviceDetectForHandoff = async() => {
      await frontEndLogs('Mitek process in handoff - ' + await this.getApplicationIDInstorage(), false, 200, 'sendDeviceDetectForHandoff');
      analyticsClickEvent('mitek_process_in_handoff', '');
    }

    openinstruction = (documenttype) => {
      if(documenttype === 'passport'){
        analyticsClickEvent('passport','')
      }else if(documenttype === 'ID'){
        analyticsClickEvent('driving_licence','')
      }else if(documenttype === 'VETERAN_CARD'){
        analyticsClickEvent('hm_forces_card','')
      }
        //  analyticsClickEvent('documentType_in_'+documenttype)
      this.setState({documentSteps:false,instructionsSection:true,isEnableDocumentsTabs:true,isSelectDocument:documenttype});
      }


  handleChange(value) {
    console.log('statusValue', value)
    this.setState({ isEnableDocumentsTabs: false, isSelectDocument: '' })
    sessionStorage.setItem('applicationStatus', '')
    if (value === 'decliened') {
      sessionStorage.setItem('applicationStatus', 'decliened')
    } else if (value === 'success') {
      sessionStorage.setItem('applicationStatus', 'success')
    } else if (value === 'refer') {
      sessionStorage.setItem('applicationStatus', 'refer')
    } else if (value === 'Manual Review') {
      sessionStorage.setItem('applicationStatus', 'Manual Review')
    } else {
      sessionStorage.setItem('applicationStatus', '')
    }
    window.location.reload();

  }

      handleLoaderStatus = (value) => {
        this.setState({isLoading: value})
      }

      passportInstructionOpen(){
        this.openinstruction('passport')
        frontEndLogs('The user selected the passport document ' + this.getApplicationIDInstorage(), false, 200, 'passportInstructionOpen');
        analyticsClickEvent('passport_document_selected', '');
      }

      IDInstructionOpen(){
        this.openinstruction('ID')
        frontEndLogs('The user selected the Driving License document ' + this.getApplicationIDInstorage(), false, 200, 'IDInstructionOpen');
        analyticsClickEvent('driving_license_document_selected', '');
      }

      veteranInstructionOpen(){
        this.openinstruction('VETERAN_CARD')
        frontEndLogs('The user selected the veteran card document ' + this.getApplicationIDInstorage(), false, 200, 'veteranInstructionOpen');
        analyticsClickEvent('veteran_card_document_selected', '');
      }

      redirectToPurchaseURLIfExists = () => {
        frontEndLogs('The user selected the veteran card document ' + this.getApplicationIDInstorage(), false, 200, 'redirectToPurchaseURLIfExists');
        analyticsClickEvent('veteran_card_document_selected', '');
        window.location.href = sessionStorage.getItem('redirectPurchaseURL');

        sessionStorage.setItem('buttonLabel', '');
        sessionStorage.setItem('redirectPurchaseURL', '');
      }

      handleRetryLoaderStatus = (value) => {
        this.props.handleRetryLoader(value);
      }

      getApplicationIDInstorage(){
        const cookie = new Cookies();
        return sessionStorage.getItem('applicationId') ? sessionStorage.getItem('applicationId') :cookie.get('applicationId')
      }

    render() {
      const {isConnected} = this.state;
      if(sessionStorage.getItem('applicationStatus')===''){
        return (
          <>
          <div className={!isConnected ? 'd-block' : 'd-none'}>
            <div className="appfrom-section instruction-wrapper">
                  <div className="mit-container">
                      <div className="complete-section">
                          <div className="logo-area">
                              <img src="images/humm-logo.svg" alt="Humm" />
                          </div>
                          <div className="complete-content">
                              Please check your internet connection and try again.
                          </div>

                          <div className="modal-footer mb-4 mx-auto border-top-0">
                                <button className="btn btn-warning btn-outline" onClick={(_e) => { 
                                  window.location.reload()
                                  this.setState({isConnected: true})
                                   }}>Try Again</button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className={isConnected ? 'd-block' : 'd-none'}>
          <Loader loaderStatus={this.state.isLoading} />
          <div className="step-final mobile-view-scan">
          {this.state.isEnableDocumentsTabs === false &&
          <div className="mit-container">
            <p className="mit-mobile-app">Finally, let’s upload your ID. Please select and upload one of the documents listed below.</p>
            <div className="mit-document-section">
              <div className="mit-inner-box">
                <Link to="#" onClick={this.passportInstructionOpen}>
                  <span className="inner-left">
                    <img src="images/passport.svg" alt="Card" />
                  </span>
                  <span className="inner-center">
                    <p>Passport</p>
                  </span>
                  <span className="inner-right">
                    <img src="images/circle-outline.png" alt="Success" />
                  </span>
                </Link>
              </div>
              <div className="mit-inner-box">
                <Link to='#' onClick={this.IDInstructionOpen}>
                  <span className="inner-left">
                    <img src="images/driving-license.svg" alt="Card" />
                  </span>
                  <span className="inner-center">
                    <p>Driving Licence</p>
                  </span>
                  <span className="inner-right">
                    <img src="images/circle-outline.png" alt="Success" />
                  </span>
                </Link>
              </div>
              <div className="mit-inner-box">
                <Link to="#" onClick={this.veteranInstructionOpen}>
                  <span className="inner-left">
                    <img src="images/hm-force-card1.svg" alt="Card" />
                  </span>
                  <span className="inner-center">
                    <p>HM Forces Card</p>
                  </span>
                  <span className="inner-right">
                    <img src="images/circle-outline.png" alt="Success" />
                  </span>
                </Link>
              </div>
            </div>
          </div>
      }
      {/* {this.state.documentSteps === false && this.state.instructionsSection === true &&
    <div class="mit-container">
                   <div class="instructions-section">
                   <h4 class="application-qr-sub-title">INSTRUCTIONS</h4>
                   <div class="instruction-message">
                       <h6>Steps to capture the document correctly</h6>
                   </div>
                   <div class="suggetion-message">
                       <span class="icon-area">
                           <img src="images/progress-success.svg" alt="Success" />
                       </span>
                       <span class="message-area">
                           <p>Please place the document on a dark, plain background to ensure the best result
                           </p>
                       </span>
                   </div>
                   <div class="suggetion-message">
                       <span class="icon-area">
                           <img src="images/progress-success.svg" alt="Success" />
                       </span>
                       <span class="message-area">
                           <p>All four corners of the document must be visible in the frame</p>
                       </span>
                   </div>
                   <div class="suggetion-message">
                       <span class="icon-area">
                           <img src="images/progress-success.svg" alt="Success" />
                       </span>
                       <span class="message-area">
                           <p>Avoid any glare, shadows or dark spots on the ID document</p>
                       </span>
                   </div>
                   <div class="suggetion-message">
                       <span class="icon-area">
                           <img src="images/progress-success.svg" alt="Success" />
                       </span>
                       <span class="message-area">
                           <p>Hold the device steady while image is being captured</p>
                       </span>
                   </div>
                   <div class="bottom-button-area">
                       <button class="btn btn-warning"  onClick={() => this.gotoSelectDocument()}>Continue</button>
                   </div>
               </div>
               </div>
              } */}
      {this.state.isEnableDocumentsTabs === true &&
         <Instructions documentType = {this.state.isSelectDocument} ref={this.child} handleLoader={this.handleLoaderStatus} handleRetryLoader={this.handleRetryLoaderStatus} handleChnage= {this.handleChange} fromWhere={'handoff'}/>
      }  

      </div>
      </div>
      </>
      )
      } else {
        return this.renderApplicationStatus();
      }
        
      }

  renderApplicationStatus = () => {
    const applicationStatus = sessionStorage.getItem('applicationStatus');
    const finalMessage = sessionStorage.getItem('finalMessage');
    const buttonLabel = sessionStorage.getItem('buttonLabel');

    // Return empty section for unknown status
    if (!['decliened', 'success', 'refer', 'Manual Review'].includes(applicationStatus)) {
      return (
        <div className="appfrom-section instruction-wrapper">
          <p></p>
        </div>
      );
    }

    // Get title based on status
    const getTitle = () => {
      switch(applicationStatus) {
        case 'success': return 'Approved';
        case 'refer': return 'Application Under Review';
        case 'Manual Review': return null;
        case 'decliened': return null;
        default: return null;
      }
    };

    const title = getTitle();
    const hasContent = finalMessage && finalMessage !== '';

    return (
      <div className="appfrom-section instruction-wrapper">
        <div className="mit-container">
          <div className="complete-section">
            <div className="logo-area">
              <img src="images/humm-logo.svg" alt="Humm" />
            </div>
            
            {/* Handle declined status - different structure */}
            {applicationStatus === 'decliened' ? (
              <>
                {hasContent && (
                  <div className="complete-content">
                    {parse(finalMessage)}
                  </div>
                )}
                {buttonLabel && (
                  <button className="btn btn-primary" onClick={this.redirectToPurchaseURLIfExists}>
                    {buttonLabel}
                  </button>
                )}
              </>
            ) : (
              /* Handle other statuses - standard structure */
              <div className="complete-content">
                {title && <h4>{title}</h4>}
                {hasContent && <p>{parse(finalMessage)}</p>}
                {buttonLabel && (
                  <button className="btn btn-primary" onClick={this.redirectToPurchaseURLIfExists}>
                    {buttonLabel}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

DocumentVerifyMobile.propTypes = {
  navigate: PropTypes.object,
  handleRetryLoader: PropTypes.bool
}

export default withRouter(DocumentVerifyMobile);